import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "./Localization";
import { MessageTypeEnum } from "../../enums";

export function ConfirmDialog(props) {
    var msgIsString = typeof props.message === "string" || props.message instanceof String;
    var message = msgIsString ? props.message.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>") : props.message;

    var lines = message.split("<br/>");
    var maxLength = Math.max(...lines.map(el => el.length));
    var height = 80 + (Math.floor(maxLength / 100) + lines.length) * 20;
    var heightProp = height > 180 ? `${height}px` : "180px";

    return (
        <div id="ConfirmDialog">
            <Dialog title={props.title} onClose={props.onCloseHandler} width={props.width} height={heightProp}>
                <div className="dialog-icon">{props.icon}</div>
                <div className="dialog-message">{msgIsString ? <span dangerouslySetInnerHTML={{ __html: message }} /> : message}</div>
                <DialogActionsBar>
                    {props.buttons.map((button, index) => {
                        return (
                            <Button key={index} className={index == 0 ? "k-primary" : ""} onClick={button.callback}>
                                {button.message}
                            </Button>
                        );
                    })}
                </DialogActionsBar>
            </Dialog>
        </div>
    );
}

export function getTitle(TYPE) {
    switch (TYPE) {
        case MessageTypeEnum.INFORMATIVE:
            return "INFORMACE";
        case MessageTypeEnum.EXCLAMATION:
            return "VAROVÁNÍ";
        case MessageTypeEnum.CRITICAL:
            return "CHYBA";
        case MessageTypeEnum.QUESTION:
            return "DOTAZ";
        default:
            return "INFORMACE";
    }
}

export function getIcon(TYPE) {
    switch (TYPE) {
        case MessageTypeEnum.INFORMATIVE:
            return <span className="k-icon k-i-information" style={{ color: "blue", fontSize: "32px" }}></span>;
        case MessageTypeEnum.EXCLAMATION:
            return <span className="k-icon k-i-warning" style={{ color: "orange", fontSize: "32px" }}></span>;
        case MessageTypeEnum.CRITICAL:
            return <span className="k-icon k-i-close-outline" style={{ color: "red", fontSize: "32px" }}></span>;
        case MessageTypeEnum.QUESTION:
            return <span className="k-icon k-i-question" style={{ color: "orange", fontSize: "32px" }}></span>;
        default:
            return <span className="k-icon k-i-information" style={{ color: "blue", fontSize: "32px" }}></span>;
    }
}



// WEBPACK FOOTER //
// ./src/components/common/ConfirmDialog.js